module.exports = __webpack_public_path__ + "img/ico-pencil.a28eb0b5.svg";